<template>
	<DaModalFrame v-model:open="modalIsOpen">
		<DeleteScheduleStudent
			v-if="modalType === _MODAL_TYPE.DELETE"
			@close="closeModal"
			@submit="deleteSubmit"
		/>
		<DeleteConfirm
			v-if="modalType === _MODAL_TYPE.DELETE_MANY"
			:data="selected"
			@close="closeModal"
			@submit="deleteManySubmit"
		/>
		<UpdateCalenderDaycareStudent
			v-if="modalType === 'DAYCARE_CALENDAR' && student"
			:boarding="daycareEditClass"
			:days="daycareEditDays"
			:student="student"
			@close="closeModal"
			@updated="onDaycareCalendarUpdated"
		/>
	</DaModalFrame>
	<div :class="isOpenCreated ? 'side-over--active' : ''">
		<div
			v-if="isOpenCreated"
			class="
				fixed
				h-screen
				w-screen
				top-0
				left-0
				bg-black
				opacity-20
				z-30
			"
			@click="isOpenCreated = false"
		></div>
		<CreateTimeSlotStudent
			:data="dataUpdate"
			:data-create="{
				student_timetable_id,
				activated_date,
			}"
			:day="day_of_week"
			:open="isOpenCreated"
			@close="isOpenCreated = false"
			@success="success"
		/>
	</div>
	<div>
		<div v-if="!isLoading" class="__student-detail pb-30">
			<div class="__goal-management-student-detail p-10 md-down:px-4">
				<div class="flex items-center justify-between">
					<div
						class="
							__breadcrumbs
							text-sm text-neutral-500
							font-semibold
							flex-nowrap flex
							items-center
						"
					>
						<router-link to="/schedule/timetable">
							Thời khoá biểu
						</router-link>
						<div class="__breadcrumbs__decorate">
							<DaIcon
								class="transform -rotate-90 h-3 w-3 mx-2"
								name="das--chevron-down"
							/>
						</div>
						<div>Tạo thời khoá biểu</div>
					</div>
					<button
						class="
							button-p
							text-center
							w-fit
							btn--text
							text-neutral-500
							hover:text-neutral-600
						"
						type="button"
						@click="$router.back()"
					>
						<svg
							class="mr-2 text-neutral-400"
							fill="none"
							height="16"
							viewBox="0 0 16 16"
							width="16"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M1.5 7.99996L0.719131 7.37526L0.219375 7.99996L0.719131 8.62465L1.5 7.99996ZM7.5 8.99996C8.05228 8.99996 8.5 8.55224 8.5 7.99996C8.5 7.44767 8.05228 6.99996 7.5 6.99996V8.99996ZM3.3858 4.04193L0.719131 7.37526L2.28087 8.62465L4.94754 5.29132L3.3858 4.04193ZM0.719131 8.62465L3.3858 11.958L4.94754 10.7086L2.28087 7.37526L0.719131 8.62465ZM1.5 8.99996H7.5V6.99996H1.5V8.99996Z"
								fill="currentColor"
							/>
							<path
								d="M7.78738 13.3439L8.31032 12.4915L7.78738 13.3439ZM6.97976 12.3905L6.05301 12.7662L6.97976 12.3905ZM14.499 12.5015L15.3875 12.9603L14.499 12.5015ZM12.7525 13.981L12.4461 13.0291L12.7525 13.981ZM14.499 3.49854L15.3875 3.0398L14.499 3.49854ZM13.8333 6.81921V9.18087H15.8333V6.81921H13.8333ZM7.83325 5.42133V5.29122H5.83325V5.42133H7.83325ZM9.58524 12.7782C8.62733 12.6186 8.43551 12.5683 8.31032 12.4915L7.26445 14.1962C7.80406 14.5273 8.47961 14.6216 9.25644 14.751L9.58524 12.7782ZM5.83325 10.7107C5.83325 11.4979 5.81518 12.1795 6.05301 12.7662L7.90651 12.0148C7.85132 11.8787 7.83325 11.6814 7.83325 10.7107H5.83325ZM8.31032 12.4915C8.12826 12.3798 7.98675 12.2128 7.90651 12.0148L6.05301 12.7662C6.29374 13.36 6.71828 13.8612 7.26445 14.1962L8.31032 12.4915ZM13.8333 9.18087C13.8333 10.0882 13.8325 10.7099 13.7946 11.1876C13.7573 11.6573 13.6894 11.8898 13.6104 12.0428L15.3875 12.9603C15.6428 12.4658 15.742 11.929 15.7883 11.3458C15.834 10.7705 15.8333 10.0557 15.8333 9.18087H13.8333ZM9.25644 14.751C10.1198 14.8949 10.8251 15.0132 11.4002 15.0628C11.9832 15.113 12.5291 15.1035 13.0589 14.9329L12.4461 13.0291C12.2822 13.0819 12.0416 13.1107 11.5719 13.0702C11.0943 13.029 10.4806 12.9275 9.58524 12.7782L9.25644 14.751ZM13.6104 12.0428C13.3679 12.5125 12.9493 12.8671 12.4461 13.0291L13.0589 14.9329C14.0653 14.609 14.9025 13.8997 15.3875 12.9603L13.6104 12.0428ZM9.58645 3.22163C10.4814 3.07248 11.0948 2.97099 11.5722 2.92986C12.0416 2.88942 12.2822 2.91819 12.4461 2.97096L13.0589 1.06717C12.5292 0.896646 11.9834 0.887021 11.4005 0.937243C10.8256 0.986778 10.1206 1.10503 9.25766 1.24885L9.58645 3.22163ZM15.8333 6.81921C15.8333 5.9444 15.834 5.22954 15.7883 4.65428C15.742 4.07104 15.6428 3.53429 15.3875 3.0398L13.6104 3.95728C13.6894 4.1103 13.7573 4.34283 13.7946 4.81252C13.8325 5.29019 13.8333 5.91191 13.8333 6.81921H15.8333ZM12.4461 2.97096C12.9493 3.13294 13.3679 3.48755 13.6104 3.95728L15.3875 3.0398C14.9025 2.10035 14.0653 1.39113 13.0589 1.06717L12.4461 2.97096ZM9.25766 1.24885C8.83685 1.31898 8.47124 1.37935 8.17099 1.45102C7.85987 1.52528 7.55473 1.62545 7.26252 1.80503L8.30967 3.50898C8.35038 3.48397 8.42887 3.44565 8.63532 3.39637C8.85265 3.3445 9.13857 3.29628 9.58645 3.22163L9.25766 1.24885ZM7.83325 5.29122C7.83325 4.83715 7.83381 4.5472 7.84925 4.3243C7.86391 4.11256 7.88881 4.02884 7.90679 3.98457L6.05387 3.23179C5.92477 3.54955 5.87613 3.86701 5.85403 4.1861C5.8327 4.49405 5.83325 4.86461 5.83325 5.29122H7.83325ZM7.26252 1.80503C6.71792 2.13971 6.29446 2.63958 6.05387 3.23179L7.90679 3.98457C7.98699 3.78717 8.12814 3.62054 8.30967 3.50898L7.26252 1.80503Z"
								fill="currentColor"
							/>
						</svg>
						Thoát
					</button>
				</div>
				<div class="__goal-management-student-detail__header pt-5">
					<div
						class="
							flex
							justify-between
							items-center
							w-full
							md-down:flex-col md-down:items-start
							gap-8
						"
					>
						<div class="flex items-center">
							<img
								v-if="student?.profile_photo?.w200"
								:src="student?.profile_photo?.w200"
								class="
									shadow-sm
									inline-block
									h-14
									w-14
									rounded-full
								"
								style="min-width: 56px"
							/>
							<span
								v-else
								:style="{
									background:
										student?.profile_photo?.default?.color,
								}"
								class="
									inline-flex
									items-center
									justify-center
									h-14
									w-14
									rounded-full
								"
								style="min-width: 56px"
							>
								<span
									class="
										font-medium
										leading-none
										text-white text-4xl
									"
									>{{
										student?.profile_photo?.default?.initial
									}}</span
								>
							</span>
							<div class="ml-4">
								<div
									class="
										font-bold
										text-neutral-700 text-4xl
										md-down:text-2xl
									"
								>
									{{ student?.name }}
								</div>
								<div
									v-if="student?.age"
									class="
										text-green-500
										font-semibold
										text-xs
										uppercase
										letter-spacing-8
									"
								>
									{{ student?.age }}
									{{
										student?.learning_time
											? `| ${student?.learning_time}`
											: ''
									}}
								</div>
							</div>
						</div>
					</div>
					<div class="w-full my-10">
						<div class="border-b border-neutral-200">
							<nav
								aria-label="Tabs"
								class="-mb-px flex space-x-8 tabs"
							>
								<div
									v-for="tab in tabs"
									:key="tab.id"
									:class="
										tabSelected === tab.id
											? 'border-b-2 text-yellow-700 border-yellow-500'
											: 'text-neutral-400'
									"
									class="
										border-transparent
										hover:text-yellow-700
										hover:border-yellow-500
										whitespace-nowrap
										py-3
										px-1
										border-b-2
										cursor-pointer
									"
									@click="tabSelected = tab.id"
								>
									<div class="flex items-center gap-2">
										<DaIcon
											v-if="tab.icon"
											:name="tab.icon"
											class="h-5 w-5"
										></DaIcon>
										<div>
											{{ tab.name }}
										</div>
									</div>
								</div>
							</nav>
						</div>
					</div>
					<div class="flex items-center justify-end">
						<button
							v-if="tabSelected == 3 || tabSelected == 0"
							:class="
								!selected.length
									? 'cursor-not-allowed'
									: 'btn--ghost cursor-pointer'
							"
							:disabled="!selected?.length"
							class="button-p w-fit px-4 gap-2"
							type="button"
							@click="openModal(_MODAL_TYPE.DELETE_MANY)"
						>
							<svg
								class="mb-1"
								fill="none"
								height="16"
								viewBox="0 0 16 16"
								width="16"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									clip-rule="evenodd"
									d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM5.35355 4.64645C5.15829 4.45118 4.84171 4.45118 4.64645 4.64645C4.45118 4.84171 4.45118 5.15829 4.64645 5.35355L7.29289 8L4.64645 10.6464C4.45118 10.8417 4.45118 11.1583 4.64645 11.3536C4.84171 11.5488 5.15829 11.5488 5.35355 11.3536L8 8.70711L10.6464 11.3536C10.8417 11.5488 11.1583 11.5488 11.3536 11.3536C11.5488 11.1583 11.5488 10.8417 11.3536 10.6464L8.70711 8L11.3536 5.35355C11.5488 5.15829 11.5488 4.84171 11.3536 4.64645C11.1583 4.45118 10.8417 4.45118 10.6464 4.64645L8 7.29289L5.35355 4.64645Z"
									fill="currentColor"
									fill-rule="evenodd"
								/>
							</svg>

							Xoá buổi học
						</button>
					</div>
					<div
						v-if="
							tabSelected === 0 &&
							(applyRangeLabel || nextApplyDate)
						"
						class="mt-6"
					>
						<div
							v-if="applyRangeLabel"
							class="text-xl font-semibold text-neutral-600"
						>
							{{ applyRangeLabel }}
						</div>
						<div
							v-if="nextApplyDate"
							:class="
								applyRangeLabel
									? 'mt-1 text-base font-normal text-neutral-500'
									: 'font-semibold text-neutral-600'
							"
						>
							Thời khoá biểu mới sẽ áp dụng vào
							{{ nextApplyDate }}.
						</div>
					</div>
					<div class="flex gap-8">
						<div v-for="schedule in [1]" :key="schedule">
							<div>
								<div
									class="
										mt-6
										border border-neutral-200
										rounded-lg
									"
									style="max-width: 600px"
								>
									<div
										v-for="index in days"
										:key="index"
										:class="{
											'border-b border-neutral-200':
												index !== 7,
											'rounded-t-lg': index === 1,
											'rounded-b-lg': index === 7,
										}"
										class="
											flex
											bg-neutral-100
											items-center
											justify-start
										"
									>
										<div
											class="
												p-5
												h-full
												font-semibold
												text-xs
												text-neutral-600
												text-center
											"
											style="width: 150px; height: 100%"
										>
											{{
												index === 7
													? 'Chủ nhật'
													: `Thứ ${index + 1}`
											}}
										</div>
										<div
											class="
												p-4
												w-full
												bg-white
												flex
												items-center
											"
											style="min-height: 72px"
										>
											<div
												v-if="
													getTimeTableData(
														schedule,
														index
													).length
												"
												class="
													flex flex-col
													gap-2
													w-full
												"
											>
												<div
													v-for="(
														dataItem, i
													) in getTimeTableData(
														schedule,
														index
													)"
													:key="i"
													class="
														flex
														justify-between
														items-center
														h-full
														w-full
													"
												>
													<div
														class="
															flex
															items-center
															gap-7
															w-full
														"
														v-if="
															isPendingChange(
																dataItem
															) ||
															is_greater_than_or_equal(
																get_date(
																	dataItem.day_of_week
																),
																dataItem.activated_date
															)
														"
													>
														<Checkbox
															v-if="
																dataItem.is_personal_class &&
																schedule == 1 &&
																(!dataItem.is_future_slot ||
																	!dataItem.deactivated_date)
															"
															:value="
																selected.includes(
																	dataItem.id
																)
															"
															@click.stop="
																onselect(
																	dataItem.id
																)
															"
														/>
														<div>
															<div
																v-if="
																	dataItem.day_care_class &&
																	schedule ==
																		1
																"
																:class="[
																	dataItem.overlapped
																		? 'bg-sienna-100'
																		: 'bg-lime-100',
																	tabSelected ==
																	3
																		? 'ml-12'
																		: '',
																]"
																class="
																	p-2
																	border-l-2
																	border-lime-600
																	rounded-lg
																	mb-2
																	flex
																	items-center
																	justify-between
																	gap-2
																	w-full
																"
																style="
																	width: 175px;
																"
															>
																<div
																	class="
																		font-semibold
																		text-neutral-600
																		whitespace-nowrap
																		truncate
																		text-sm
																	"
																>
																	{{
																		dataItem
																			.day_care_class
																			.name
																	}}
																</div>
																<div>
																	<svg
																		fill="none"
																		height="20"
																		viewBox="0 0 21 20"
																		width="21"
																		xmlns="http://www.w3.org/2000/svg"
																	>
																		<path
																			d="M6.32967 20C6.54702 19.9999 6.7621 19.9559 6.96204 19.8706C7.16198 19.7854 7.34265 19.6607 7.49323 19.5039C7.64381 19.3472 7.7612 19.1617 7.83837 18.9585C7.91554 18.7553 7.95089 18.5386 7.94232 18.3214L7.67208 9.88249L8.84971 9.17284C9.1501 8.99077 9.39658 8.73196 9.56378 8.42305C9.73098 8.11413 9.81287 7.76625 9.80104 7.41518L9.56595 0.617447C9.56025 0.453467 9.49108 0.298112 9.37303 0.184158C9.25498 0.0702041 9.09727 0.00656322 8.93319 0.00666215C8.76989 0.00828381 8.61354 0.0729825 8.49684 0.187227C8.38014 0.301471 8.31213 0.456412 8.30703 0.619645L8.14225 4.85559C8.14082 4.98185 8.09413 5.1034 8.01067 5.19815C7.92721 5.2929 7.81252 5.35455 7.68746 5.37191C7.61798 5.37951 7.54768 5.37268 7.48096 5.35184C7.41424 5.33101 7.35255 5.29662 7.29975 5.25082C7.24694 5.20503 7.20417 5.14883 7.1741 5.08573C7.14403 5.02264 7.12732 4.95401 7.12501 4.88416L6.96023 0.643812C6.95636 0.498377 6.90447 0.358308 6.81267 0.245442C6.72087 0.132576 6.5943 0.0532551 6.4527 0.0198446C6.36835 0.00562738 6.2822 0.00562738 6.19784 0.0198446C6.05624 0.0532551 5.92968 0.132576 5.83788 0.245442C5.74607 0.358308 5.69419 0.498377 5.69032 0.643812L5.52554 4.88416C5.52323 4.95401 5.50652 5.02264 5.47645 5.08573C5.44638 5.14883 5.40361 5.20503 5.3508 5.25082C5.298 5.29662 5.2363 5.33101 5.16959 5.35184C5.10287 5.37268 5.03257 5.37951 4.96309 5.37191C4.83803 5.35455 4.72334 5.2929 4.63988 5.19815C4.55642 5.1034 4.50973 4.98185 4.5083 4.85559L4.33693 0.619645C4.33175 0.45336 4.2613 0.295802 4.14082 0.181078C4.02034 0.0663532 3.85952 0.00369344 3.69319 0.00666215C3.52911 0.00656322 3.3714 0.0702041 3.25335 0.184158C3.1353 0.298112 3.06613 0.453467 3.06043 0.617447L2.83413 7.41738C2.82229 7.76844 2.90419 8.11632 3.07139 8.42524C3.23859 8.73416 3.48507 8.99296 3.78546 9.17503L4.98506 9.89567L4.71482 18.3214C4.70624 18.5388 4.74166 18.7557 4.81896 18.959C4.89627 19.1623 5.01385 19.3479 5.16467 19.5047C5.31549 19.6615 5.49642 19.7862 5.69661 19.8713C5.89681 19.9564 6.11213 20.0002 6.32967 20Z"
																			fill="#65A30D"
																		/>
																		<path
																			d="M18.1455 8.24569C18.4582 7.6708 18.62 7.026 18.6157 6.37159C18.6003 4.22065 18.2114 0.0220559 15.1202 8.5179e-05C12.0289 -0.0218855 11.64 4.21187 11.6246 6.37159C11.6197 7.0258 11.7807 7.6706 12.0926 8.24569C12.4232 8.85577 12.9109 9.3663 13.5053 9.72431L13.7953 9.90008L13.5273 18.3214C13.5193 18.5355 13.5546 18.7489 13.631 18.9489C13.7074 19.149 13.8234 19.3316 13.972 19.4858C14.1206 19.64 14.2988 19.7627 14.4959 19.8465C14.6929 19.9303 14.9049 19.9735 15.1191 19.9735C15.3332 19.9735 15.5452 19.9303 15.7423 19.8465C15.9394 19.7627 16.1175 19.64 16.2661 19.4858C16.4147 19.3316 16.5307 19.149 16.6071 18.9489C16.6835 18.7489 16.7188 18.5355 16.7108 18.3214L16.4362 9.89568L16.7262 9.71992C17.3225 9.36403 17.8125 8.855 18.1455 8.24569Z"
																			fill="#65A30D"
																		/>
																	</svg>
																</div>
															</div>
															<div
																v-if="
																	!dataItem.day_care_class
																"
																:class="[
																	dataItem.deactivated_date
																		? 'overlay'
																		: '',
																	dataItem.overlapped
																		? 'bg-sienna-100 border-sienna-600'
																		: dataItem.group_class_id
																		? 'bg-blue-100 border-blue-600'
																		: 'bg-violet-100 border-violet-600',
																]"
																class="
																	p-2
																	border-l-2
																	rounded-lg
																	flex
																	w-full
																	items-center
																	justify-between
																"
																style="
																	width: 175px;
																"
															>
																<div
																	class="
																		font-semibold
																		text-neutral-600
																		whitespace-nowrap
																		text-sm
																	"
																	:class="{
																		'text-overlay':
																			!!dataItem.deactivated_date,
																	}"
																>
																	{{
																		dataItem.display_start_slot
																	}}
																	-
																	{{
																		dataItem.display_end_slot
																	}}
																</div>
																<Popper
																	:arrow="
																		true
																	"
																	hover
																>
																	<div
																		class="
																			flex
																			items-center
																			justify-end
																			gap-1
																		"
																		:class="
																			dataItem.deactivated_date
																				? 'opacity-30'
																				: ''
																		"
																	>
																		<div
																			v-for="(
																				staff_id,
																				i
																			) in dataItem.staff_ids?.slice(
																				0,
																				2
																			)"
																			:key="
																				staff_id
																			"
																			class="
																				flex
																				items-center
																			"
																		>
																			<div
																				class="
																					h-6
																					w-6
																				"
																			>
																				<img
																					v-if="
																						getStaff(
																							staff_id
																						)
																							?.profile_photo
																							?.w200
																					"
																					:src="
																						getStaff(
																							staff_id
																						)
																							?.profile_photo
																							?.w200
																					"
																					alt=""
																					class="
																						shadow-sm
																						w-full
																						h-full
																						rounded-full
																					"
																					:class="{
																						'm-avatar':
																							dataItem
																								.staff_ids
																								?.length >
																								2 &&
																							i ==
																								1,
																					}"
																				/>
																				<div
																					v-else
																					:style="{
																						background:
																							getStaff(
																								staff_id
																							)
																								?.profile_photo
																								?.default
																								?.color,
																					}"
																					:class="{
																						'm-avatar':
																							dataItem
																								.staff_ids
																								?.length >
																								2 &&
																							i ==
																								1,
																					}"
																					class="
																						flex
																						items-center
																						justify-center
																						h-6
																						w-6
																						rounded-full
																					"
																				>
																					<div
																						class="
																							font-medium
																							leading-none
																							text-white
																							text-xs
																						"
																					>
																						{{
																							getStaff(
																								staff_id
																							)
																								?.profile_photo
																								?.default
																								?.initial
																						}}
																					</div>
																				</div>
																			</div>
																		</div>
																		<div
																			v-if="
																				dataItem
																					.staff_ids
																					?.length >
																				2
																			"
																			class="
																				flex
																				items-center
																				m-number
																			"
																		>
																			<div
																				class="
																					h-6
																					w-6
																				"
																			>
																				<div
																					class="
																						flex
																						items-center
																						justify-center
																						h-6
																						w-6
																						rounded-full
																						bg-gray-300
																					"
																				>
																					<div
																						class="
																							font-semibold
																							leading-none
																							text-white
																							text-xs
																						"
																					>
																						+{{
																							dataItem
																								.staff_ids
																								?.length -
																							2
																						}}
																					</div>
																				</div>
																			</div>
																		</div>
																	</div>
																	<template
																		#content
																	>
																		<div
																			class="
																				flex
																				flex-wrap
																				gap-3
																			"
																			style="
																				max-width: 360px;
																			"
																		>
																			<div
																				v-if="
																					dataItem.deactivated_date
																				"
																				class="
																					text-base
																				"
																			>
																				<div
																					class="
																						font-semibold
																					"
																				>
																					Ngày
																					tạo:

																					<span
																						class="
																							font-normal
																						"
																					>
																						{{
																							formatDate(
																								dataItem.inserted_at
																							)
																						}}
																					</span>
																				</div>
																				<div
																					class="
																						font-semibold
																					"
																				>
																					Tạo
																					bởi:
																					<span
																						class="
																							font-normal
																						"
																					>
																						{{
																							dataItem
																								.created_by_staff
																								?.name
																						}}
																					</span>
																				</div>
																				<div
																					class="
																						font-semibold
																					"
																				>
																					Áp
																					dụng
																					vào:

																					<span
																						class="
																							font-normal
																						"
																					>
																						{{
																							formatDate(
																								dataItem.inserted_at
																							)
																						}}
																					</span>
																				</div>
																			</div>
																			<div
																				v-else
																				v-for="(
																					item,
																					index
																				) in [
																					...dataItem.staff_ids,
																				].reverse()"
																				:key="
																					getStaff(
																						item
																					)
																						?.id
																				"
																				class="
																					flex
																					flex-nowrap
																					gap-3
																					items-center
																				"
																				style="
																					width: 160px;
																				"
																			>
																				<div
																					:style="{
																						zIndex:
																							dataItem
																								?.staff_ids
																								?.length -
																							index,
																					}"
																					class="
																						rounded-full
																					"
																				>
																					<img
																						v-if="
																							getStaff(
																								item
																							)
																								?.profile_photo
																								?.w200
																						"
																						:class="`h-9 w-9`"
																						:src="
																							getStaff(
																								item
																							)
																								?.profile_photo
																								?.w200
																						"
																						alt=""
																						class="
																							shadow-sm
																							inline-block
																							rounded-full
																						"
																					/>
																					<span
																						v-else
																						:class="`h-9 w-9`"
																						:style="{
																							background:
																								getStaff(
																									item
																								)
																									?.profile_photo
																									?.default
																									?.color,
																						}"
																						class="
																							inline-flex
																							items-center
																							justify-center
																							rounded-full
																						"
																					>
																						<span
																							class="
																								font-medium
																								leading-none
																								text-white
																								text-xs
																							"
																							>{{
																								getStaff(
																									item
																								)
																									?.profile_photo
																									?.default
																									?.initial
																							}}</span
																						>
																					</span>
																				</div>
																				<div
																					:style="{
																						color: getStaff(
																							item
																						)
																							?.profile_photo
																							?.default
																							?.color,
																					}"
																					class="
																						font-semibold
																						cursor-pointer
																						hover:underline
																						text-sm
																						py-1
																					"
																					@click.stop="
																						$router.push(
																							`/record/staff/${
																								getStaff(
																									item
																								)
																									.id
																							}`
																						)
																					"
																				>
																					{{
																						getStaff(
																							item
																						)
																							?.name
																					}}
																				</div>
																			</div>
																		</div>
																	</template>
																</Popper>
															</div>
														</div>
													</div>
													<Menu
														v-if="
															dataItem.day_care_class
														"
														as="div"
														class="ml-3 relative"
													>
														<div>
															<MenuButton
																class="
																	rounded-full
																	flex
																	text-sm
																	focus:outline-none
																"
															>
																<span
																	class="
																		sr-only
																	"
																	>Mở menu</span
																>
																<svg
																	fill="none"
																	height="20"
																	viewBox="0 0 20 20"
																	width="20"
																	xmlns="http://www.w3.org/2000/svg"
																>
																	<path
																		clip-rule="evenodd"
																		d="M11.875 16.25C11.875 17.2855 11.0355 18.125 10 18.125C8.96447 18.125 8.125 17.2855 8.125 16.25C8.125 15.2145 8.96447 14.375 10 14.375C11.0355 14.375 11.875 15.2145 11.875 16.25ZM11.875 10C11.875 11.0355 11.0355 11.875 10 11.875C8.96447 11.875 8.125 11.0355 8.125 10C8.125 8.96447 8.96447 8.125 10 8.125C11.0355 8.125 11.875 8.96447 11.875 10ZM11.875 3.75C11.875 4.78553 11.0355 5.625 10 5.625C8.96447 5.625 8.125 4.78553 8.125 3.75C8.125 2.71447 8.96447 1.875 10 1.875C11.0355 1.875 11.875 2.71447 11.875 3.75Z"
																		fill="#94A3B8"
																		fill-rule="evenodd"
																	/>
																</svg>
															</MenuButton>
														</div>
														<transition
															enter-active-class="transition ease-out duration-200"
															enter-from-class="transform opacity-0 scale-95"
															enter-to-class="transform opacity-100 scale-100"
															leave-active-class="transition ease-in duration-75"
															leave-from-class="transform opacity-100 scale-100"
															leave-to-class="transform opacity-0 scale-95"
														>
															<MenuItems
																class="
																	origin-top-right
																	absolute
																	right-0
																	mt-2
																	w-52
																	rounded-md
																	py-1
																	bg-white
																	focus:outline-none
																	z-10
																	shadow-sm
																	border
																	border-yellow-100
																"
															>
																<MenuItem
																	@click="
																		openDaycareEdit(
																			dataItem
																		)
																	"
																>
																	<div
																		class="
																			p-2
																			px-4
																			bg-white
																			text-gray-600
																			hover:bg-neutral-50
																			flex
																			items-center
																			gap-4
																			cursor-pointer
																		"
																	>
																		<DaIcon
																			class="
																				h-4
																				w-4
																				text-neutral-400
																			"
																			name="das--pen"
																		/>
																		<span
																			>Chỉnh
																			sửa</span
																		>
																	</div>
																</MenuItem>
																<MenuItem
																	@click="
																		openDaycareDelete(
																			dataItem
																		)
																	"
																>
																	<div
																		class="
																			p-2
																			px-4
																			bg-white
																			text-gray-600
																			hover:bg-neutral-50
																			flex
																			items-center
																			gap-4
																			cursor-pointer
																		"
																	>
																		<DaIcon
																			class="
																				h-4
																				w-4
																				text-neutral-400
																			"
																			name="das--delete"
																		/>
																		<span
																			>Xoá
																			buổi
																			học</span
																		>
																	</div>
																</MenuItem>
															</MenuItems>
														</transition>
													</Menu>
													<Menu
														v-if="
															!dataItem.day_care_class
														"
														as="div"
														class="ml-3 relative"
													>
														<div>
															<MenuButton
																class="
																	rounded-full
																	flex
																	text-sm
																	focus:outline-none
																	focus:ring-2
																	focus:ring-offset-2
																	focus:ring-indigo-500
																"
															>
																<span
																	class="
																		sr-only
																	"
																	>Open user
																	menu</span
																>
																<svg
																	fill="none"
																	height="20"
																	viewBox="0 0 20 20"
																	width="20"
																	xmlns="http://www.w3.org/2000/svg"
																>
																	<path
																		clip-rule="evenodd"
																		d="M11.875 16.25C11.875 17.2855 11.0355 18.125 10 18.125C8.96447 18.125 8.125 17.2855 8.125 16.25C8.125 15.2145 8.96447 14.375 10 14.375C11.0355 14.375 11.875 15.2145 11.875 16.25ZM11.875 10C11.875 11.0355 11.0355 11.875 10 11.875C8.96447 11.875 8.125 11.0355 8.125 10C8.125 8.96447 8.96447 8.125 10 8.125C11.0355 8.125 11.875 8.96447 11.875 10ZM11.875 3.75C11.875 4.78553 11.0355 5.625 10 5.625C8.96447 5.625 8.125 4.78553 8.125 3.75C8.125 2.71447 8.96447 1.875 10 1.875C11.0355 1.875 11.875 2.71447 11.875 3.75Z"
																		fill="#94A3B8"
																		fill-rule="evenodd"
																	/>
																</svg>
															</MenuButton>
														</div>
														<transition
															enter-active-class="transition ease-out duration-200"
															enter-from-class="transform opacity-0 scale-95"
															enter-to-class="transform opacity-100 scale-100"
															leave-active-class="transition ease-in duration-75"
															leave-from-class="transform opacity-100 scale-100"
															leave-to-class="transform opacity-0 scale-95"
														>
															<MenuItems
																class="
																	origin-top-right
																	absolute
																	right-0
																	mt-2
																	w-60
																	rounded-md
																	py-1
																	bg-white
																	focus:outline-none
																	z-10
																	shadow-sm
																	border
																	border-yellow-100
																"
															>
																<MenuItem
																	v-slot="{
																		active,
																	}"
																	@click="
																		openCreated(
																			index
																		)
																	"
																	v-if="
																		dataItem.is_personal_class
																	"
																>
																	<div
																		:class="
																			active
																				? ''
																				: ''
																		"
																		class="
																			p-2
																			px-4
																			bg-white
																			z-10
																			text-gray-600
																			hover:bg-neutral-50
																			flex
																			items-center
																			gap-4
																			cursor-pointer
																		"
																	>
																		<svg
																			fill="none"
																			height="16"
																			viewBox="0 0 16 16"
																			width="16"
																			xmlns="http://www.w3.org/2000/svg"
																		>
																			<path
																				clip-rule="evenodd"
																				d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM8.5 4.5C8.5 4.22386 8.27614 4 8 4C7.72386 4 7.5 4.22386 7.5 4.5V7.5H4.5C4.22386 7.5 4 7.72386 4 8C4 8.27614 4.22386 8.5 4.5 8.5H7.5V11.5C7.5 11.7761 7.72386 12 8 12C8.27614 12 8.5 11.7761 8.5 11.5V8.5H11.5C11.7761 8.5 12 8.27614 12 8C12 7.72386 11.7761 7.5 11.5 7.5H8.5V4.5Z"
																				fill="#94A3B8"
																				fill-rule="evenodd"
																			/>
																		</svg>

																		<span
																			class="
																				mt-0.5
																			"
																			>Thêm
																			buổi
																			học</span
																		>
																	</div>
																</MenuItem>
																<MenuItem
																	v-slot="{
																		active,
																	}"
																	@click="
																		openCreated(
																			index,
																			dataItem
																		)
																	"
																	v-if="
																		dataItem.is_personal_class
																	"
																>
																	<div
																		:class="
																			active
																				? ''
																				: ''
																		"
																		class="
																			p-2
																			px-4
																			bg-white
																			z-10
																			text-gray-600
																			hover:bg-neutral-50
																			flex
																			items-center
																			gap-4
																			cursor-pointer
																		"
																	>
																		<svg
																			fill="none"
																			height="16"
																			viewBox="0 0 16 16"
																			width="16"
																			xmlns="http://www.w3.org/2000/svg"
																		>
																			<path
																				clip-rule="evenodd"
																				d="M12.47 6.65175L13.71 5.41172C13.8459 5.27586 13.9138 5.20793 13.9664 5.14597C14.6006 4.39929 14.6006 3.30311 13.9664 2.55644C13.9138 2.49448 13.8459 2.42655 13.71 2.29069C13.5741 2.15482 13.5062 2.08689 13.4442 2.03426C12.6976 1.40004 11.6014 1.40004 10.8547 2.03426C10.7928 2.08688 10.7249 2.15479 10.5891 2.29059L10.589 2.29067L10.589 2.29069L9.33075 3.5489C10.0744 4.84309 11.1581 5.91837 12.47 6.65175ZM7.87608 5.00356L2.86248 10.0172C2.43742 10.4422 2.22489 10.6547 2.08516 10.9158C1.94542 11.1769 1.88648 11.4717 1.76859 12.0611L1.37293 14.0394C1.30641 14.372 1.27315 14.5383 1.36776 14.6329C1.46237 14.7275 1.62867 14.6943 1.96128 14.6277L3.93956 14.2321L3.93958 14.2321L3.9396 14.2321C4.52902 14.1142 4.82374 14.0553 5.08483 13.9155C5.34592 13.7758 5.55845 13.5633 5.98349 13.1382L5.98352 13.1382L5.98352 13.1382L11.0115 8.11019C9.75086 7.31198 8.68177 6.25011 7.87608 5.00356Z"
																				fill="#94A3B8"
																				fill-rule="evenodd"
																			/>
																		</svg>

																		<span
																			class="
																				mt-0.5
																			"
																			>Chỉnh
																			sửa
																			buổi
																			học</span
																		>
																	</div>
																</MenuItem>
																<MenuItem
																	v-slot="{
																		active,
																	}"
																	@click="
																		openDeleteConfirm(
																			dataItem.id
																		)
																	"
																	v-if="
																		dataItem.is_personal_class
																	"
																>
																	<div
																		:class="
																			active
																				? ''
																				: ''
																		"
																		class="
																			p-2
																			px-4
																			bg-white
																			z-10
																			text-gray-600
																			hover:bg-neutral-50
																			flex
																			items-center
																			gap-4
																			cursor-pointer
																		"
																	>
																		<svg
																			fill="none"
																			height="16"
																			viewBox="0 0 16 16"
																			width="16"
																			xmlns="http://www.w3.org/2000/svg"
																		>
																			<path
																				clip-rule="evenodd"
																				d="M2.5 1C1.94772 1 1.5 1.44772 1.5 2V3C1.5 3.55228 1.94772 4 2.5 4H3V13C3 14.1046 3.89543 15 5 15H11C12.1046 15 13 14.1046 13 13V4H13.5C14.0523 4 14.5 3.55228 14.5 3V2C14.5 1.44772 14.0523 1 13.5 1H10C10 0.447715 9.55229 0 9 0H7C6.44772 0 6 0.447715 6 1H2.5ZM5.5 5C5.77614 5 6 5.22386 6 5.5V12.5C6 12.7761 5.77614 13 5.5 13C5.22386 13 5 12.7761 5 12.5L5 5.5C5 5.22386 5.22386 5 5.5 5ZM8 5C8.27614 5 8.5 5.22386 8.5 5.5V12.5C8.5 12.7761 8.27614 13 8 13C7.72386 13 7.5 12.7761 7.5 12.5V5.5C7.5 5.22386 7.72386 5 8 5ZM11 5.5C11 5.22386 10.7761 5 10.5 5C10.2239 5 10 5.22386 10 5.5V12.5C10 12.7761 10.2239 13 10.5 13C10.7761 13 11 12.7761 11 12.5V5.5Z"
																				fill="#94A3B8"
																				fill-rule="evenodd"
																			/>
																		</svg>

																		<span
																			class="
																				mt-0.5
																			"
																			>Xoá
																			buổi
																			học</span
																		>
																	</div>
																</MenuItem>
																<MenuItem
																	v-slot="{
																		active,
																	}"
																	@click="
																		$router.push(
																			`/daycare-class/${dataItem.day_care_class.id}`
																		)
																	"
																	v-if="
																		dataItem.day_care_class
																	"
																>
																	<div
																		:class="
																			active
																				? ''
																				: ''
																		"
																		class="
																			p-2
																			px-4
																			bg-white
																			z-10
																			text-gray-600
																			hover:bg-neutral-50
																			flex
																			items-center
																			gap-4
																			cursor-pointer
																		"
																	>
																		<svg
																			fill="none"
																			height="16"
																			viewBox="0 0 16 16"
																			width="16"
																			xmlns="http://www.w3.org/2000/svg"
																		>
																			<path
																				clip-rule="evenodd"
																				d="M12.47 6.65175L13.71 5.41172C13.8459 5.27586 13.9138 5.20793 13.9664 5.14597C14.6006 4.39929 14.6006 3.30311 13.9664 2.55644C13.9138 2.49448 13.8459 2.42655 13.71 2.29069C13.5741 2.15482 13.5062 2.08689 13.4442 2.03426C12.6976 1.40004 11.6014 1.40004 10.8547 2.03426C10.7928 2.08688 10.7249 2.15479 10.5891 2.29059L10.589 2.29067L10.589 2.29069L9.33075 3.5489C10.0744 4.84309 11.1581 5.91837 12.47 6.65175ZM7.87608 5.00356L2.86248 10.0172C2.43742 10.4422 2.22489 10.6547 2.08516 10.9158C1.94542 11.1769 1.88648 11.4717 1.76859 12.0611L1.37293 14.0394C1.30641 14.372 1.27315 14.5383 1.36776 14.6329C1.46237 14.7275 1.62867 14.6943 1.96128 14.6277L3.93956 14.2321L3.93958 14.2321L3.9396 14.2321C4.52902 14.1142 4.82374 14.0553 5.08483 13.9155C5.34592 13.7758 5.55845 13.5633 5.98349 13.1382L5.98352 13.1382L5.98352 13.1382L11.0115 8.11019C9.75086 7.31198 8.68177 6.25011 7.87608 5.00356Z"
																				fill="#94A3B8"
																				fill-rule="evenodd"
																			/>
																		</svg>

																		<span
																			class="
																				mt-0.5
																			"
																			>Chỉnh
																			sửa</span
																		>
																	</div>
																</MenuItem>
																<MenuItem
																	v-slot="{
																		active,
																	}"
																	@click="
																		$router.push(
																			`/group-classes/${dataItem.group_class_id}`
																		)
																	"
																	v-if="
																		dataItem.group_class_id
																	"
																>
																	<div
																		:class="
																			active
																				? ''
																				: ''
																		"
																		class="
																			p-2
																			px-4
																			bg-white
																			z-10
																			text-gray-600
																			hover:bg-neutral-50
																			flex
																			items-center
																			gap-4
																			cursor-pointer
																		"
																	>
																		<svg
																			fill="none"
																			height="16"
																			viewBox="0 0 16 16"
																			width="16"
																			xmlns="http://www.w3.org/2000/svg"
																		>
																			<path
																				clip-rule="evenodd"
																				d="M12.47 6.65175L13.71 5.41172C13.8459 5.27586 13.9138 5.20793 13.9664 5.14597C14.6006 4.39929 14.6006 3.30311 13.9664 2.55644C13.9138 2.49448 13.8459 2.42655 13.71 2.29069C13.5741 2.15482 13.5062 2.08689 13.4442 2.03426C12.6976 1.40004 11.6014 1.40004 10.8547 2.03426C10.7928 2.08688 10.7249 2.15479 10.5891 2.29059L10.589 2.29067L10.589 2.29069L9.33075 3.5489C10.0744 4.84309 11.1581 5.91837 12.47 6.65175ZM7.87608 5.00356L2.86248 10.0172C2.43742 10.4422 2.22489 10.6547 2.08516 10.9158C1.94542 11.1769 1.88648 11.4717 1.76859 12.0611L1.37293 14.0394C1.30641 14.372 1.27315 14.5383 1.36776 14.6329C1.46237 14.7275 1.62867 14.6943 1.96128 14.6277L3.93956 14.2321L3.93958 14.2321L3.9396 14.2321C4.52902 14.1142 4.82374 14.0553 5.08483 13.9155C5.34592 13.7758 5.55845 13.5633 5.98349 13.1382L5.98352 13.1382L5.98352 13.1382L11.0115 8.11019C9.75086 7.31198 8.68177 6.25011 7.87608 5.00356Z"
																				fill="#94A3B8"
																				fill-rule="evenodd"
																			/>
																		</svg>

																		<span
																			class="
																				mt-0.5
																			"
																			>Chỉnh
																			sửa</span
																		>
																	</div>
																</MenuItem>
															</MenuItems>
														</transition>
													</Menu>
												</div>
											</div>
											<div
												v-else
												class="
													flex
													items-center
													w-full
													justify-between
													h-full
												"
											>
												<div
													class="
														text-neutral-400 text-lg
													"
												>
													Học sinh chưa có buổi học
													nào
												</div>
												<Menu
													v-if="tabSelected !== 1"
													as="div"
													class="ml-3 relative"
												>
													<div>
														<MenuButton
															class="
																rounded-full
																flex
																text-sm
																focus:outline-none
																focus:ring-2
																focus:ring-offset-2
																focus:ring-indigo-500
															"
														>
															<span
																class="sr-only"
																>Open user
																menu</span
															>
															<svg
																fill="none"
																height="20"
																viewBox="0 0 20 20"
																width="20"
																xmlns="http://www.w3.org/2000/svg"
															>
																<path
																	clip-rule="evenodd"
																	d="M11.875 16.25C11.875 17.2855 11.0355 18.125 10 18.125C8.96447 18.125 8.125 17.2855 8.125 16.25C8.125 15.2145 8.96447 14.375 10 14.375C11.0355 14.375 11.875 15.2145 11.875 16.25ZM11.875 10C11.875 11.0355 11.0355 11.875 10 11.875C8.96447 11.875 8.125 11.0355 8.125 10C8.125 8.96447 8.96447 8.125 10 8.125C11.0355 8.125 11.875 8.96447 11.875 10ZM11.875 3.75C11.875 4.78553 11.0355 5.625 10 5.625C8.96447 5.625 8.125 4.78553 8.125 3.75C8.125 2.71447 8.96447 1.875 10 1.875C11.0355 1.875 11.875 2.71447 11.875 3.75Z"
																	fill="#94A3B8"
																	fill-rule="evenodd"
																/>
															</svg>
														</MenuButton>
													</div>
													<transition
														enter-active-class="transition ease-out duration-200"
														enter-from-class="transform opacity-0 scale-95"
														enter-to-class="transform opacity-100 scale-100"
														leave-active-class="transition ease-in duration-75"
														leave-from-class="transform opacity-100 scale-100"
														leave-to-class="transform opacity-0 scale-95"
													>
														<MenuItems
															class="
																origin-top-right
																absolute
																right-0
																mt-2
																w-60
																rounded-md
																py-1
																bg-white
																focus:outline-none
																z-10
																shadow-sm
																border
																border-yellow-100
															"
														>
															<MenuItem
																v-slot="{
																	active,
																}"
																@click="
																	openCreated(
																		index
																	)
																"
															>
																<div
																	:class="
																		active
																			? ''
																			: ''
																	"
																	class="
																		p-2
																		px-4
																		bg-white
																		z-10
																		text-gray-600
																		hover:bg-neutral-50
																		flex
																		items-center
																		gap-4
																		cursor-pointer
																	"
																>
																	<svg
																		fill="none"
																		height="16"
																		viewBox="0 0 16 16"
																		width="16"
																		xmlns="http://www.w3.org/2000/svg"
																	>
																		<path
																			clip-rule="evenodd"
																			d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM8.5 4.5C8.5 4.22386 8.27614 4 8 4C7.72386 4 7.5 4.22386 7.5 4.5V7.5H4.5C4.22386 7.5 4 7.72386 4 8C4 8.27614 4.22386 8.5 4.5 8.5H7.5V11.5C7.5 11.7761 7.72386 12 8 12C8.27614 12 8.5 11.7761 8.5 11.5V8.5H11.5C11.7761 8.5 12 8.27614 12 8C12 7.72386 11.7761 7.5 11.5 7.5H8.5V4.5Z"
																			fill="#94A3B8"
																			fill-rule="evenodd"
																		/>
																	</svg>

																	<span
																		class="
																			mt-0.5
																		"
																		>Thêm
																		buổi
																		học</span
																	>
																</div>
															</MenuItem>
														</MenuItems>
													</transition>
												</Menu>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-else class="fixed top-1/2 left-1/2">
			<Loading />
		</div>
	</div>
</template>

<script>
import Loading from '@/components/common/Loading';
import DaIcon from '@/components/elements/daIcon/DaIcon';
import { $api } from '@/services';
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue';
import DeleteScheduleStudent from '@/views/timeTableStudent/features/DeleteScheduleStudent';
import DaModalFrame from '@/components/common/daModalFrame/DaModalFrame';
import CreateTimeSlotStudent from '@/views/timeTableStudent/features/createTimeSlotStudent';
import dayjs from 'dayjs';
import Popper from 'vue3-popper';
import Checkbox from '@/components/elements/checkbox/Checkbox.vue';
import DeleteConfirm from '@/views/timeTableStudent/features/DeleteConfirm.vue';
import UpdateCalenderDaycareStudent from '@/views/daycareClassDetail/features/UpdateCalenderDaycareStudent.vue';
import { _MODAL_TYPE } from '@/enums';

export default {
	name: 'TimeTableStudent',
	components: {
		Popper,
		DeleteConfirm,
		Checkbox,
		CreateTimeSlotStudent,
		UpdateCalenderDaycareStudent,
		DeleteScheduleStudent,
		DaModalFrame,
		DaIcon,
		Loading,
		Menu,
		MenuItem,
		MenuItems,
		MenuButton,
	},

	data() {
		return {
			isLoading: true,
			student: null,
			data: [],
			staffs: {},
			modalIsOpen: false,
			isOpenCreated: false,
			deletedId: '',
			day_of_week: null,
			dataUpdate: null,
			student_timetable_id: '',
			activated_date: '',
			selected: [],
			modalType: '',
			tabSelected:
				{ daycare: 1, group: 2 }[
					this.$route.query.type || this.$route.query.tab
				] || 0,
			daycareEditClass: null,
			daycareEditDays: [],
			daycareDeleteItem: null,
			tabs: [
				{
					id: 0,
					name: 'Học cá nhân',
					icon: 'das--book',
				},
				{
					id: 1,
					name: 'Học bán trú',
					icon: 'das--spoon',
				},
				{
					id: 2,
					name: 'Học nhóm',
					icon: 'das--users',
				},
				{
					id: 3,
					name: 'Tất cả',
				},
			],
			params: {
				date: dayjs().format('YYYY-MM-DD'),
				student_id: this.$route.params.id,
				include_future_slot: true,
			},
			dataStudent: [],
			dataDaycare: [],
			groupClass: [],
			hasFutureTimetable: false,
			applyRange: null,
			is_current_applied: false,
		};
	},

	computed: {
		_MODAL_TYPE() {
			return _MODAL_TYPE;
		},
		studentId() {
			return this.$route.params.id;
		},

		applyDate() {
			return Date.now();
		},

		activatedDate() {
			const applyDate = this.$route.query.apply_date;
			const date = Array.isArray(applyDate) ? applyDate[0] : applyDate;
			return date && dayjs(date).isValid()
				? dayjs(date).format('YYYY-MM-DD')
				: dayjs().format('YYYY-MM-DD');
		},

		org() {
			return this.$store.state.profile.current_org;
		},

		days() {
			return [
				this.org?.monday ? 1 : undefined,
				this.org?.tuesday ? 2 : undefined,
				this.org?.wednesday ? 3 : undefined,
				this.org?.thursday ? 4 : undefined,
				this.org?.friday ? 5 : undefined,
				this.org?.saturday ? 6 : undefined,
				this.org?.sunday ? 7 : undefined,
			].filter((item) => !!item);
		},

		futureApplyDate() {
			const today = dayjs().format('YYYY-MM-DD');
			const dates = [
				...new Set(
					(this.dataStudent || [])
						.filter(
							(item) =>
								item?.activated_date &&
								item.activated_date > today
						)
						.map((item) => item.activated_date)
				),
			].sort();
			if (!dates.length) return '';
			return dayjs(dates[0]).format('DD/MM/YYYY');
		},

		applyRangeLabel() {
			if (!this.applyRange?.start_date) return '';
			const { start_date, end_date } = this.applyRange;
			const prefix = this.is_current_applied ? 'TKB hiện tại · ' : '';
			return (
				prefix +
				'Áp dụng từ ' +
				this.$filters.formatDate2(start_date) +
				(end_date
					? ' đến ' +
					  this.$filters.formatDate2(
							dayjs(end_date)
								.subtract(1, 'day')
								.format('YYYY-MM-DD')
					  )
					: '')
			);
		},

		// start_date có thể null khi hiện tại chưa có buổi học nhưng đã có
		// buổi học sẽ áp dụng trong tương lai
		nextApplyDate() {
			if (!this.applyRange) return this.futureApplyDate;
			if (!this.applyRange.end_date) return '';
			return this.$filters.formatDate2(this.applyRange.end_date);
		},
	},
	watch: {
		tabSelected() {
			this.applySelectedTab();
		},
	},
	created() {
		const activatedDate = this.$route.query.activated_date;
		const date = Array.isArray(activatedDate)
			? activatedDate[0]
			: activatedDate;
		if (date) {
			this.params.date = date;
		}
		this.getStudentDetail();
		this.getStudentTimetable();
		this.fetchStaffs();
	},

	methods: {
		openModal(type) {
			this.modalType = type;
			this.modalIsOpen = true;
		},

		closeModal() {
			this.modalType = '';
			this.modalIsOpen = false;
			this.daycareDeleteItem = null;
		},

		applySelectedTab() {
			switch (this.tabSelected) {
				case 0:
					this.data = [...(this.dataStudent || [])];
					break;
				case 1:
					this.data = [...(this.dataDaycare || [])];
					break;
				case 2:
					this.data = [...(this.groupClass || [])];
					break;
				case 3:
					this.data = [
						...(this.dataStudent || []),
						...(this.dataDaycare || []),
						...(this.groupClass || []),
					];
					break;
			}
		},

		daycareDays(classId) {
			return [
				...new Set(
					(this.dataDaycare || [])
						.filter(
							(item) => item.day_care_class?.id === classId
						)
						.map((item) => item.day_of_week)
				),
			];
		},

		openDaycareEdit(item) {
			this.daycareDeleteItem = null;
			this.daycareEditClass = item.day_care_class;
			this.daycareEditDays = this.daycareDays(item.day_care_class?.id);
			this.openModal('DAYCARE_CALENDAR');
		},

		openDaycareDelete(item) {
			this.daycareDeleteItem = item;
			this.openModal(_MODAL_TYPE.DELETE);
		},

		async onDaycareCalendarUpdated() {
			this.closeModal();
			await this.getStudentTimetable();
		},

		async getStudentDetail() {
			try {
				const {
					data: { data },
				} = await $api.student.getStudent(this.studentId);
				this.student = data;
				this.isLoading = false;
			} catch (err) {
				console.log(err);
			}
		},

		async getStudentTimetable() {
			try {
				const res1 = await $api.schedule.fetchTimetableByWeek(
					this.params
				);
				this.dataStudent = res1.data.data;
				this.applyRange = res1.data.apply_range || null;
				this.is_current_applied = !!res1.data?.is_current_applied;
				const res2 =
					await $api.schedule.fetchFixedDaycareScheduleByWeek({
						date: this.params.date,
						student_id: this.studentId,
					});
				const classesMap = res2?.data?.day_care_classes_map || {};
				this.dataDaycare = (res2?.data?.data || [])
					.map((slot) => ({
						...slot,
						day_care_class: classesMap[slot.day_care_class_id],
					}))
					.filter((slot) => slot.day_care_class);
				const res3 = await $api.schedule.fetchFixedGroupTimeSlotsByWeek({
					date: this.params.date,
					student_id: this.studentId,
				});
				this.groupClass = res3?.data?.data || [];

				let dataTable = {};
				const {
					data: { data },
				} = await $api.schedule.studentTimetable(this.studentId, {
					apply_date: this.applyDate,
				});
				dataTable = data;
				if (!data) {
					const {
						data: { data: data_table },
					} = await $api.schedule.createTimeTableStudent(
						this.studentId,
						{
							student_timetable: {
								activated_date: this.activatedDate,
							},
						}
					);
					dataTable = data_table;
				}
				this.student_timetable_id = dataTable.id;
				this.activated_date = dataTable.activated_date;
				this.applySelectedTab();
				this.hasFutureTimetable = res1.data.has_future_timetable;
			} catch (err) {
				console.log(err);
			}
		},

		isPendingChange(item) {
			if (!item) return false;
			if (item.deactivated_date || item.is_future_slot) return true;
			if (!item.activated_date) return false;
			return !this.is_greater_than_or_equal(
				this.get_date(item.day_of_week),
				item.activated_date
			);
		},

		getTimeTableData(schedule, day) {
			const slots = this.data.filter(
				(item) => item.day_of_week === day
			);
			if (schedule !== 1) return [];
			const changed = [];
			const current = [];
			slots.forEach((item) => {
				if (this.isPendingChange(item)) changed.push(item);
				else if (
					this.is_greater_than_or_equal(
						this.get_date(item.day_of_week),
						item.activated_date
					)
				) {
					current.push(item);
				}
			});
			changed.sort((a, b) => {
				const rank = (slot) =>
					slot.is_future_slot && !slot.deactivated_date ? 0 : 1;
				return rank(a) - rank(b);
			});
			return [...changed, ...current];
		},

		getStaff(staff_id) {
			return this.staffs[staff_id];
		},

		async fetchStaffs() {
			try {
				const {
					data: { data },
				} = await $api.staff.getEmployees('');
				const staffs = {};
				(data || []).forEach((staff) => {
					staffs[staff.id] = staff;
				});
				this.staffs = staffs;
			} catch (err) {
				console.log(err);
			}
		},

		openCreated(day, d) {
			this.isOpenCreated = true;
			this.day_of_week = day;

			if (d) {
				this.dataUpdate = d;
			} else {
				this.dataUpdate = null;
			}
		},

		async deleteSubmit() {
			if (this.daycareDeleteItem) {
				await this.deleteDaycareSlot();
				return;
			}
			try {
				await $api.schedule.deleteTimeSlotStudent(this.deletedId);
				this.closeModal();
				await this.getStudentTimetable();
				await this.$store.dispatch('setAlertMessage', {
					message: 'Đã xóa thành công buổi học',
				});
			} catch (err) {
				console.log(err);
			}
		},

		async deleteDaycareSlot() {
			const item = this.daycareDeleteItem;
			const classId = item?.day_care_class?.id;
			try {
				await $api.boarding.updateCalenderStudent({
					day_care_class_id: classId,
					student_id: this.student?.id,
					days_of_week: this.daycareDays(classId).filter(
						(day) => day !== item.day_of_week
					),
				});
				this.closeModal();
				await this.getStudentTimetable();
				await this.$store.dispatch('setAlertMessage', {
					message: 'Đã xóa thành công buổi học',
				});
			} catch (err) {
				this.$store.dispatch('setAlertMessage', {
					message:
						err?.response?.data?.errors?.join('<br/>') ||
						'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			}
		},

		async deleteManySubmit() {
			try {
				await $api.schedule.deleteManyTimeSlotStudent({
					ids: this.selected,
				});
				this.closeModal();
				await this.getStudentTimetable();
				await this.$store.dispatch('setAlertMessage', {
					message: 'Đã xóa thành công buổi học',
				});
			} catch (err) {
				console.log(err);
			}
		},

		openDeleteConfirm(id) {
			this.deletedId = id;
			this.openModal(_MODAL_TYPE.DELETE);
		},

		async success() {
			try {
				const res1 = await $api.schedule.fetchTimetableByWeek(
					this.params
				);
				this.dataStudent = res1.data.data;
				this.applyRange = res1.data.apply_range || null;
				this.is_current_applied = !!res1.data?.is_current_applied;
				this.applySelectedTab();
				this.isOpenCreated = false;
				this.hasFutureTimetable = res1.data.has_future_timetable;
			} catch (err) {
				console.log(err);
			}
		},

		onselect(item) {
			if (this.selected.includes(item)) {
				this.selected = this.selected.filter((i) => i !== item);
			} else {
				this.selected.push(item);
			}
		},
		formatDate(data) {
			let dtObject = new Date(data);
			dtObject.setUTCHours(dtObject.getHours() + 7);
			if (dtObject.getHours() >= 24) {
				dtObject.setDate(dtObject.getDate() + 1);
			}
			let newTimestamp = dtObject
				.toISOString()
				.replace('T', ' ')
				.slice(0, -5);
			return newTimestamp;
		},

		get_date(day_of_week) {
			// Get the current date
			const currentDate = new Date();

			// Get the current day of the week (0 - Sunday, 1 - Monday, ..., 6 - Saturday)
			const currentDay = currentDate.getDay();

			// Calculate the difference in days
			const diff = day_of_week - currentDay;

			// Get the date for the specified day in the current week
			const resultDate = new Date(currentDate);
			resultDate.setDate(currentDate.getDate() + diff);

			// Format the date to YYYY-MM-DD
			const year = resultDate.getFullYear();
			const month = String(resultDate.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so we add 1
			const day = String(resultDate.getDate()).padStart(2, '0');

			return `${year}-${month}-${day}`;
		},
		is_greater_than_or_equal(date_1, date_2) {
			// Convert the date strings to Date objects
			const d1 = new Date(date_1);
			const d2 = new Date(date_2);

			// Compare the dates and return true if date_1 is greater than or equal to date_2
			return d1 >= d2;
		},
		get_date_for_next_week(day_of_week) {
			// Get the current date
			const currentDate = new Date();

			// Get the current day of the week (0 - Sunday, 1 - Monday, ..., 6 - Saturday)
			const currentDay = currentDate.getDay();

			// Calculate the difference in days (to the specified day in next week)
			const diff = day_of_week - currentDay + 7; // Add 7 to move to the next week

			// Get the date for the specified day in the next week
			const resultDate = new Date(currentDate);
			resultDate.setDate(currentDate.getDate() + diff);

			// Format the date to YYYY-MM-DD
			const year = resultDate.getFullYear();
			const month = String(resultDate.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so we add 1
			const day = String(resultDate.getDate()).padStart(2, '0');

			return `${year}-${month}-${day}`;
		},
	},
};
</script>
<style scoped>
.m-avatar {
	margin-left: -14px;
}
.m-number {
	margin-left: -28px;
}
.overlay {
	background-color: #f5f5fc !important;
	border-left: 2px solid #cbcef6 !important;
}
.text-overlay {
	color: #c4c9cf !important;
}
</style>
